import type MemberModel from '@/models/entities/MemberModel';
import type TeamMemberModel from '@/models/entities/TeamMemberModel';

/** Membres d'une équipe pour l'organigramme : son manager (au plus un, règle de l'API) et ses équipiers, triés par NOM puis prénom */
export interface TeamComposition {
  manager: TeamMemberModel | null;
  teammates: TeamMemberModel[];
}

const byName = (a: TeamMemberModel, b: TeamMemberModel) =>
  a.lastName.localeCompare(b.lastName, 'fr') || a.firstName.localeCompare(b.firstName, 'fr');

/**
 * Direction de la société en haut de l'organigramme : par position du rôle dans la société (Dirigeants, puis Assistants),
 * puis par NOM et prénom. La position n'étant pas en base, l'API ne peut pas trier dessus (liste courte, chargée entière).
 */
export function sortDirection(members: MemberModel[]): MemberModel[] {
  return [...members].sort(
    (a, b) =>
      a.companyRolePosition - b.companyRolePosition ||
      a.lastName.localeCompare(b.lastName, 'fr') ||
      a.firstName.localeCompare(b.firstName, 'fr'),
  );
}

export function composeTeam(members: TeamMemberModel[]): TeamComposition {
  const active = members.filter((member) => member.isActive);

  return {
    manager: active.find((member) => member.isManager) ?? null,
    teammates: active.filter((member) => !member.isManager).sort(byName),
  };
}

/** « 1 membre », « 3 membres » (activeMemberCount de l'équipe : manager compris) */
export function memberCountLabel(count: number | null | undefined): string {
  const value = count ?? 0;
  return `${value} membre${value > 1 ? 's' : ''}`;
}
